import React from 'react';
import { Save, UserPlus } from 'lucide-react';
import ActionButton from '../../../components/Buttons/ActionButton';

interface Props {
  isSubmitting: boolean;
  onSubmit: () => void;
  onCancel?: () => void;
  label?: string;
  icon?: 'create' | 'save';
}

const UserSubmitButton: React.FC<Props> = ({
  isSubmitting,
  onSubmit,
  onCancel,
  label,
  icon = 'create',
}) => {
  const text = label ?? 'Registrar Usuario';
  const Icon = icon === 'save' ? Save : UserPlus;

  return (
    <div className="flex items-center justify-end gap-3 border-t border-stroke pt-5 dark:border-strokedark">
      {onCancel && (
        <ActionButton
          label="Cancelar"
          variant="secondary"
          onClick={onCancel}
          disabled={isSubmitting}
          fullWidth={false}
        />
      )}
      <ActionButton
        label={text}
        loadingLabel="Procesando..."
        loading={isSubmitting}
        onClick={onSubmit}
        icon={<Icon className="h-4 w-4" />}
        fullWidth={false}
      />
    </div>
  );
};

export default UserSubmitButton;
